import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './FindOutMore.css';
import { graphql, gql, compose } from 'react-apollo';

// Components
import FindOutMoreBanner from './FindOutMoreBanner';
import WhyBlock from '../../components/FindOutMore/WhyBlock';
import HostingBlock from '../../components/FindOutMore/HostingBlock/HostingBlock';
import CoverSection from '../../components/FindOutMore/CoverSection/CoverSection';
//import getFindOutMorePageSettings from './getFindOutMorePageSettings.graphql';
import Loader from '../../components/Loader'


// ES6 Imports
import Scroll from 'react-scroll'; // Imports all Mixins
import { scroller } from 'react-scroll'; //Imports scroller mixin, can use as scroller.scrollTo()


let Link = Scroll.Link;
let Element = Scroll.Element;
let Events = Scroll.Events;
let scroll = Scroll.animateScroll;
let scrollSpy = Scroll.scrollSpy;

class FindOutMore extends React.Component {

  render() {
    return (
      <div className="whyhost-content">
        <FindOutMoreBanner />
        <Element name="test1" className="element">
          <WhyBlock />
          <HostingBlock />
          {/* <CoverSection /> */}
        </Element>
      </div>
    );
  }

}

export default withStyles(s)(FindOutMore);

/*export default compose(
  withStyles(s),
  graphql(getFindOutMorePageSettings, {
    options: {
      fetchPolicy: 'network-only',
      ssr: false
    }
  }),
)(FindOutMore);*/



// WEBPACK FOOTER //
// src/routes/findoutmore/FindOutMore.js